import { request } from "../request";

import { checkListImageBase, checkListImageBaseByPhotoArray } from '../utils'

export const getOffers = (data) => {
    return request({
        method: 'post',
        url: '/offers/page',
        params: data
    }).then(checkListImageBase).then(res => {
        res.list = checkListImageBaseByPhotoArray(res.list)
        res.list = res.list.map(tem => {
            tem.cost = tem.cost / 100 || 0;
            tem.price = tem.price / 100 || 0;
            return tem;
        })
        return res;
    })
}

export const getTranscation = (data) => {
    return request({
        method: 'post',
        url: '/transcation/page',
        params: data
    }).then(checkListImageBase).then(res => {
        res.list = checkListImageBaseByPhotoArray(res.list)
        res.list = res.list.map(tem => {
            tem.cost = tem.cost / 100 || 0;
            tem.price = tem.price / 100 || 0;
            return tem;
        })
        return res;
    })
}

export const setOfferState = ({ offerId, status }) => {
    return request({
        method: 'post',
        url: '/offers/update-status',
        params: { offerId, status }
    })
}

export const setTranscateState = ({ transcationId, status }) => {
    return request({
        method: 'post',
        url: '/transcation/update-status',
        params: { transcationId, status }
    })
}

export const addOffers = (data) => {
    return request({
        method: 'post',
        url: '/offers/add',
        params: data
    })
}

export const addOffersBatch = (data) => {
    return request({
        method: 'post',
        url: '/offers/batch-add',
        params: data
    })
}

export const setOffers = (data) => {
    return request({
        method: 'post',
        url: '/offers/modify',
        params: data
    })
}

export const removeOffers = (data) => {
    return request({
        method: 'post',
        url: '/offers/remove',
        params: data
    })
}


export const getOfferStatistics = (data) => {
    return request({
        method: 'post',
        url: '/offers/stats',
        params: data
    })
}


export const addOfferByUpload = (data, other ) => {
    return request({
      method: 'post',
      url: '/offer-upload/add',
      params: data,
      config: {
        formData: true,
      },
      axiosConfig: {
        ...other,
      },
    });
  };
  
  export const getOfferByUpload = data => {
    return request({
      method: 'post',
      url: '/offer-upload/page',
      params: data,
    });
  };
  
  export const delOfferByUpload = data => {
    return request({
      method: 'post',
      url: '/offer-upload/delete',
      params: data,
    });
  };
  
  
  export const modifyOfferByUpload = data => {
    return request({
      method: 'post',
      url: '/offer-upload/modify',
      params: data,
    });
  };
  